import Hero from "@/components/Hero";
import ExploreGrid from "@/components/ExploreGrid";

export default function HomePage() {
  return (
    <>
      <Hero />
      <ExploreGrid />
    </>
  );
}
